import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MultiSelectComponent, MultiSelectFilter} from '../multi-select-component';
import {ToastService} from '../../services/toast.service';
import {MatCheckbox} from '@angular/material/checkbox';
import {MatDivider} from '@angular/material/divider';
import {MatButton} from '@angular/material/button';
import { VehicleModel } from '../../models/vehicle.model';
import { AssetsManagerService } from '../../../data/assets/assets-manager.service';

/**
 * This component allows to create a multi-select filter of Vehicle entities.
 * It either emits 'undefined' value if no filter is set or an array of entities.
 *
 * In addition, it saves the state of the filter to URL params and browser's storage.
 */

@Component({
  selector: 'app-vehicle-filter',
  templateUrl: './vehicle-filter.component.html',
  styleUrls: ['./vehicle-filter.component.scss'],
  imports: [
    MatCheckbox,
    MatDivider,
    MatButton
  ]
})
export class VehicleFilterComponent extends MultiSelectComponent<VehicleModel> implements OnInit {

  SETTINGS_KEY = 'selectedVehicleIds';
  USE_FULLY_CHECKED_AS_DEFAULT = false;

  @Input() origin;
  @Output() filterChanged = new EventEmitter<MultiSelectFilter<VehicleModel>>();

  constructor(
    private assetManager: AssetsManagerService,
    private readonly toast: ToastService,
  ) {
    super();
  }

  ngOnInit() {
    // delayed init to workaround failing chip label initialization :-(
    setTimeout(
      () => this.initComponent(
        this.assetManager.getVehicles()
      ),
      500,
    );
  }

  getLabel(item: VehicleModel): string {
    return item.label || item.name;
  }

  onApply() {}

}
